const grainsOilseedsOrder = [
  "canola",
  "minnWheat",
  "kcWheat",
  "wheat",
  "soybeans",
  "corn",
  "oats",
  "soybeanOil",
  "soybeanMeal"
];

export default grainsOilseedsOrder; 